import type { Organization } from '@/types'

export interface OrganizationsState {
  organizations: Organization[]
  selectedOrganization: Organization | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    isActive: boolean | null
  }
}

export const getInitialState = (): OrganizationsState => ({
  organizations: [],
  selectedOrganization: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    isActive: null,
  },
})

export const initialState: OrganizationsState = getInitialState()

export const resetState = (state: OrganizationsState): void => {
  const initial = getInitialState()
  state.organizations = initial.organizations
  state.selectedOrganization = initial.selectedOrganization
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
